import styles from './HubBadge.module.scss';
import * as React from 'react';

const Hub = ({ height, width, fill = '#ffffff' }: { height: number; width: number; fill?: string }) => {
  return (
    <svg height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 23.24">
      <g>
        <g>
          <path
            fill={fill}
            d="M30,3.31V19.94a3.31,3.31,0,0,1-3.31,3.3H3.31A3.31,3.31,0,0,1,0,19.94V3.31A3.31,3.31,0,0,1,3.31,0H26.69A3.31,3.31,0,0,1,30,3.31ZM1.77,19.94a1.54,1.54,0,0,0,1.54,1.53H26.69a1.54,1.54,0,0,0,1.54-1.53V3.31a1.54,1.54,0,0,0-1.54-1.54H3.31A1.54,1.54,0,0,0,1.77,3.31Z"
          />
          <path
            fill={fill}
            d="M23.33,4.37v14.5A1.29,1.29,0,0,1,22,20.16H5.8a1.29,1.29,0,0,1-1.29-1.29V4.37A1.29,1.29,0,0,1,5.8,3.08H22A1.29,1.29,0,0,1,23.33,4.37Zm-1.78,14V4.86H6.29V18.39Z"
          />
          <circle fill={fill} cx="25.78" cy="11.62" r="1.03" />
          <path
            fill={fill}
            d="M15.33,8.62a1.81,1.81,0,0,1,1.45,2.86h0l0,0-2.82,3.09-2.75-3a1.8,1.8,0,0,1,1.34-3,1.91,1.91,0,0,1,1.41.81A1.91,1.91,0,0,1,15.33,8.62Zm0-1.77a3.2,3.2,0,0,0-1.41.33,3.2,3.2,0,0,0-1.41-.33,3.56,3.56,0,0,0-2.67,5.93l0,0,2.75,3a1.77,1.77,0,0,0,1.31.58h0a1.79,1.79,0,0,0,1.31-.58l2.82-3.1.08-.09.05-.07h0l.06-.08a3.53,3.53,0,0,0,.66-2.06,3.57,3.57,0,0,0-3.57-3.57Z"
          />
        </g>
      </g>
    </svg>
  );
};

export const HubBadge = ({ size = 'large' }: { size?: 'large' | 'medium' | 'small' }): JSX.Element => {
  let width = 100;
  let height = 100;
  if (size === 'small') {
    width = height = 40;
  } else if (size === 'medium') {
    width = height = 80;
  }

  return (
    <div className={styles.container} style={{ width, height }}>
      <Hub width={width / 2} height={height / 2} />
    </div>
  );
};
